export enum SortingState {
   None = 'none',
   Increasing = 'increasing',
   Decresing = 'decriasing'
}

export interface ColInfo {
   name: string;
   width: number;
   key: string;
   sort: {
      state: SortingState;
   };
   search: {
      lastSearchBy: string;
   };
}



// WEBPACK FOOTER //
// ./src/app/data-models/table.typings.ts